/** @jsxImportSource @emotion/react */

import {css} from "@emotion/react";
import {GuidlinesProps} from ".";
import GuidelinesSection from "./GuidelinesSection";
import YesNoButtons from "./YesNoButtons";
import approvedSvg from "assets/images/approved.svg";
import workerSvg from "assets/images/worker.svg";
import Ul from "./Ul";
import ButtonsContainer from "./ButtonsContainer";
import QuestionTitle from "./QuestionTitle";
import {ReactComponent as EmployeesSvg} from "assets/images/users-solid.svg";
import {ReactComponent as ClipboardSvg} from "assets/images/clipboard-list-solid.svg";
import {ReactComponent as MoneyBagSvg} from "assets/images/sack-dollar-solid.svg";
import {ReactComponent as WalletSvg} from "assets/images/wallet-solid.svg";
import {ReactComponent as BuildingSvg} from "assets/images/building-solid.svg";
import {ReactComponent as WrenchSvg} from "assets/images/wrench-solid.svg";
import {ReactComponent as MedalSvg} from "assets/images/medal-solid.svg";

export default function SkpGuidelines({onYes, onNo}: GuidlinesProps) {
  return (
    <div
      css={css`
        display: flex;
        gap: 5px;
        flex-direction: column;
      `}
    >
      <QuestionTitle>
        Does this risk location meet the guidelines outlined below?{" "}
      </QuestionTitle>
      <GuidelinesSection title="Eligibility requirements" svgUrl={approvedSvg}>
        <Ul
          css={css`
            list-style-type: none; /* Remove default bullet */
            padding-left: 0; /* Remove left padding */

            li {
              display: flex;
              align-items: center;
              margin-bottom: 10px;

              &::before {
                content: "";
                display: inline-block;
              }
            }
          `}
        >
          <li>
            <EmployeesSvg
              css={css`
                width: 20px; /* Adjust the size here */
                height: 20px;
                margin-right: 10px;
                margin-right: 10px;
              `}
            />
            <div>Up to 7 employees (part time count as ½ employee)</div>
          </li>
          <li>
            <ClipboardSvg
              css={css`
                width: 20px;
                height: 20px;
                margin-right: 10px;
              `}
            />
            <div>Up to 3 classes per risk</div>
          </li>
          <li>
            <MoneyBagSvg
              css={css`
                width: 20px;
                height: 20px;
                margin-right: 10px;
              `}
            />
            <div>
              Max sales (including receipts for work subcontracted to others) -
              $1.5MM
            </div>
          </li>
          <li>
            <WalletSvg
              css={css`
                width: 20px;
                height: 20px;
                margin-right: 10px;
              `}
            />
            <div>Max payroll - $500K</div>
          </li>
          <li>
            <BuildingSvg
              css={css`
                width: 20px;
                height: 20px;
                margin-right: 10px;
              `}
            />
            <div>No exterior work over 3 stories</div>
          </li>
          <li>
            <WrenchSvg
              css={css`
                width: 20px;
                height: 20px;
                margin-right: 10px;
              `}
            />
            <div>
              NO GC's - Subcontracted work cannot exceed 20% of receipts
            </div>
          </li>
          <li>
            <MedalSvg
              css={css`
                width: 20px;
                height: 20px;
                margin-right: 10px;
              `}
            />
            <div>
              Minimum of 3 years' experience required (start-ups are allowed)
            </div>
          </li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection title="Contractor Classes" svgUrl={workerSvg}>
        <Ul>
          <li>Electrical HH Appliance Installation Repair</li>
          <li>Gas HH Appliance Installation Repair</li>
          <li>Carpentry</li>
          <li>
            Carpet, Rug, Furniture or Upholstery Cleaning – on customers'
            premises
          </li>
          <li>Concrete Construction</li>
          <li>Siding Installation</li>
          <li>Driveway, Parking Area or Sidewalk – paving or repaving</li>
          <li>Dry Wall Installation</li>
          <li>Electrical Wiring</li>
          <li>Carpet/Floor Installation</li>
          <li>Air Conditioning/ Heating Systems Work</li>
          <li>Sheet Metal Work</li>
          <li>Household Furnishings Installation/Repair</li>
          <li>Landscape Gardening</li>
          <li>Lawn Sprinkler Installation</li>
          <li>Masonry</li>
          <li>Office Machine Installation and Repair</li>
          <li>
            Painting - exterior – buildings or structures – three stories or
            less in height
          </li>
          <li>
            Painting and Paperhanging - interior – buildings or structures
          </li>
          <li>Plaster/Stucco</li>
          <li>Plumbing</li>
          <li>Tile, Stone, Marble, Terrazzo Work</li>
          <li>Fence Installation</li>
        </Ul>
      </GuidelinesSection>
      <ButtonsContainer>
        <YesNoButtons onYes={onYes} onNo={onNo} />
      </ButtonsContainer>
    </div>
  );
}
